import random from 'toxilibs/random.js'
import nGramsCommons from './commons/ngrams.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'ngrams_count_1',
    dependencies: [
        'levels/ngrams_cissors_1'
    ]
})

const {
    createQuestion,
    cutCountAndMysteryCountedGram,
    cutCountAndMysteryCount,
    realWords
} = nGramsCommons



level.addQuestion({
    generator: function (q) {
        let a = random.unmistakableLetter()
        let b = random.unmistakableLetter()
        let c = random.unmistakableLetter()

        let word = random.unmistakableLetters(random.intBetween(3, 5))
        let letters = [...word.split(''), b, b, c, c]

        let aCount = random.intBetween(3, 5)
        for (let i = 0; i < aCount; i++) {
            letters.push(a)
        }
        random.shuffleArray(letters)
        word = letters.join('')

        createQuestion(q, cutCountAndMysteryCount, {word, n: 1, pos: random.intBetween(0, 1)})
    }
})



level.addQuestion({
    generator: function (q) {
        let word = realWords()
        createQuestion(q, cutCountAndMysteryCountedGram, {word, n: 1})
    }
})






export default level

